<template>
    <div class="text-wrapper">
        <h1>Thank you for your registration for the CCA conference.</h1>
        <p>
            You will receive an email to confirm your registration.
            <!-- For assistance, please send an email to <a href="mailto:ccaconference@amsterdamumc.nl">ccaconference@amsterdamumc.nl</a> -->
            If you don't receive a confirmation, please send an email to <a href="mailto:ccaconference@amsterdamumc.nl">ccaconference@amsterdamumc.nl</a>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'v-intro-text'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .text-wrapper{
        h1{
            font-size:1.25em;
        }
        img{
            max-width:100%;
            margin:0 auto;
        }
        .img-center{
            text-align:center;
        }
        .warning-text{
            text-align:center;
            font-size:1.4em;
            .red{
                color:#f90202;
            }
        }
        font-size:1.15em;
    }
</style>
